import React from 'react';

export default function IconFI() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 22">
            <path
                fill="#F5F5F5"
                d="M31.448 21.483H.55A.552.552 0 0 1 0 20.93V1.069C0 .764.247.517.55.517h30.897c.305 0 .552.247.552.552v19.862a.552.552 0 0 1-.552.552Z"
            />
            <path
                fill="#41479B"
                d="M32 9.345H13.24V.517H9.93v8.828H0v3.31h9.93v8.828h3.31v-8.828H32v-3.31Z"
            />
        </svg>
    );
}
